import { CompositionConfig } from "../types/composition";
import {
	AudioVisualizerSchema,
	defaultAudioVisualizerProps,
} from "./constants";
import { CompositionProps, MainComposition } from "./main";
import {
	PRESETS,
	MIN_DURATION_FRAMES,
	CROSSFADE_DURATION_FRAMES,
} from "../constants";
import { calculateTotalDuration } from "../utils/calculate-duration";

export const AudioVisualizerTemplate: CompositionConfig<CompositionProps> = {
	id: "AudioVisualizer",
	component: MainComposition,
	schema: AudioVisualizerSchema,
	defaultProps: defaultAudioVisualizerProps,
	width: PRESETS.dimensions.landscape.width,
	height: PRESETS.dimensions.landscape.height,
	fps: PRESETS.fps,
	calculateMetadata: async ({ props }) => {
		const fps = PRESETS.fps;

		// Calculate total duration from provided durationInSeconds
		const totalDurationSeconds = calculateTotalDuration(props.audioTracks);

		// Account for crossfades between tracks
		// Only subtract crossfade for transitions (NOT for the last track)
		const totalCrossfades = Math.max(0, props.audioTracks.length - 1);
		const crossfadeSeconds =
			(totalCrossfades * CROSSFADE_DURATION_FRAMES) / fps;
		const adjustedDuration = totalDurationSeconds - crossfadeSeconds;

		return {
			durationInFrames: Math.ceil(
				Math.max(MIN_DURATION_FRAMES, adjustedDuration * fps),
			),
			props: {
				...props,
			},
		};
	},
};
